module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//btn-style_1.png?v=ed9655bd";